import React from "react"
import { footer } from "../../data/Data"
import "./footer.css"

const Footer = () => {
  return (
    <>
      <section className='footerContact'>
        <div className='container'>
          <div className='send flex'>
            <div className='text'>
              <h1>Ready to Find or Build Your Home?</h1>
              <p>Browse listings, request a build quote, or ask us anything — we're here to help.</p>
            </div>
            <button className='btn5'>Contact Vista Hill Houses</button>
          </div>
        </div>
      </section>

      <footer>
        <div className='container'>
          <div className='box'>
            <div className='logo'>
              <img src='/images/vista-logo-light.png' alt='vistahillhouse logo' />
              <h2>Stay in the loop</h2>
              <p>Get new listings, build tips, and Vista Hill Houses updates in your inbox.</p>

              <div className='input flex'>
                <input type='text' placeholder='Email Address' />
                <button>Subscribe</button>
              </div>
            </div>
          </div>

          {footer.map((val, index) => (
            <div className='box' key={index}>
              <h3>{val.title}</h3>
              <ul>
                {val.text.map((items) => (
                  <li> {items.list} </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </footer>
      <div className='legal'>
        <span>© {new Date().getFullYear()} Vista Hill Houses. All rights reserved.</span>
      </div>
    </>
  )
}

export default Footer
